import { AvailabilityCalculationResult } from "@gymflow/types";
import { QueryKey, queryOptions } from "@tanstack/react-query";

import { api } from "../../api";

const keys = {
  all: () => ["memberApiAvailability"] as QueryKey,
  facility: (params: unknown) =>
    [...keys.all(), "facility", params] as QueryKey,
  host: (params: unknown) => [...keys.all(), "host", params] as QueryKey,
};

export const memberApiAvailability = {
  keys,
  queries: {
    facility: (params: {
      appointableId: number | undefined;
      dateFrom: string;
      dateTo: string;
      facilityIdList?: number[];
      appointmentIdToIgnore?: number;
    }) =>
      queryOptions({
        queryKey: keys.facility(params),
        queryFn: async () => {
          return (
            await api.post<AvailabilityCalculationResult[]>(
              `/customer/availability/facility/calculate`,
              params,
            )
          ).data;
        },
        enabled: params.appointableId !== undefined,
      }),
    host: (params: {
      appointableId: number | undefined;
      dateFrom: string;
      dateTo: string;
      hostsIdList?: string[];
      appointmentIdToIgnore?: number;
    }) =>
      queryOptions({
        queryKey: keys.host(params),
        queryFn: async () => {
          return (
            await api.post<AvailabilityCalculationResult[]>(
              `/customer/availability/host/calculate`,
              params,
            )
          ).data;
        },
        enabled: params.appointableId !== undefined,
      }),
  },
  infiniteQueries: {},
  mutations: {},
};
